if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.endDate = new Date(this.dataset.endDate).getTime();
      if (!Number(this.endDate)) return;

      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.daysEl = this.querySelector('.js-days');
      this.daysItem = this.daysEl?.closest('.countdown__item');
      this.grid = this.querySelector('.countdown__grid');
      this.hoursEl = this.querySelector('.js-hours');
      this.minsEl = this.querySelector('.js-mins');
      this.secsEl = this.querySelector('.js-secs');

      this.second = 1000;
      this.minute = 60 * this.second;
      this.hour = 60 * this.minute;
      this.day = 24 * this.hour;

      this.timer();
      this.interval = setInterval(this.timer.bind(this), this.second);
    }

    timer() {
      const timeDiff = this.endDate - new Date();

      if (timeDiff < 0) {
        clearInterval(this.interval);
        this.maybeHideSection();
        return;
      }

      const days = Math.floor(timeDiff / this.day);
      const hours = Math.floor(timeDiff / this.hour);
      const mins = Math.floor(timeDiff / this.minute);
      const secs = Math.floor(timeDiff / this.second);

      const pad = (n) => String(n).padStart(2, '0');
      const hideDays = days === 0;
      if (this.daysItem) this.daysItem.hidden = hideDays;
      if (this.grid) this.grid.classList.toggle('countdown__grid--no-days', hideDays);
      this.daysEl.textContent = pad(days);
      this.hoursEl.textContent = pad(hours - days * 24);
      this.minsEl.textContent = pad(mins - hours * 60);
      this.secsEl.textContent = pad(secs - mins * 60);
    }

    maybeHideSection() {
      const wrapper = this.closest('[data-hide-section-on-end="true"]');
      if (!wrapper) return;
      const section = this.closest('.shopify-section');
      if (section) section.hidden = true;
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
